import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './index.css';
import Button from '../../../../components/common/Button/index';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { imageData, isBeneficiaryModified, isImageEdited, showCloseModal } from '@store/actions/beneficiaryAction';



interface ModalProps {
  showModal: boolean
}
const CloseModal: React.FC<ModalProps> = ({
  showModal
}) => {
  const [show, setShow] = useState<boolean>(showModal);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <Modal
        show={show}
        onHide={() => { setShow(false) }}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_close_button"
      >

        <Modal.Body className="page_modal_body">
          <div className="modal_title">Recent edits you've made to your
            beneficiary won't be saved. Do you want to continue?</div>
          <div className="modal_page_body">
            <Button
              onClick={() => {
                setShow(false)
                dispatch(showCloseModal(false))
                dispatch(isImageEdited(false));
                dispatch(isBeneficiaryModified(false))
                dispatch(imageData(''))
                navigate("/beneficiaries")
              }}
              disabled={false}
              id=""
              buttonName={'Yes'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            <Button
              onClick={() => {
                setShow(false)
                dispatch(showCloseModal(false))
              }}
              disabled={false}
              id=""
              buttonName={'No'}
              colorType={'disabled'}
              icon={''}
              iconPosition={''}
            />
          </div>

        </Modal.Body>

      </Modal>
    </>
  );
};

export default CloseModal;
